// extracted by mini-css-extract-plugin
export default {"disabled":"appLink_disabled__XQssZ"};